import { type Context, createContext } from 'react';

import type { ViewDeadAirBroker } from './types';

export const ViewDeadAirContext: Context<ViewDeadAirBroker | null> =
	createContext<ViewDeadAirBroker | null>(null);
